module.exports = __webpack_public_path__ + "img/card.65f61ccb.svg";